module.exports = __webpack_public_path__ + "img/gzh.66d25bd3.jpeg";